// import './components/menu';
// import './components/scroll';
// import './components/tabs';
// import './components/accordion';
// import './components/show-more';
// import './components/player-and-modals';
import './components/sliders';
// import './components/search';
// import './components/adapt';

import './components/anim-spec';
import './components/form';
import './components/gsap.min';
import './components/ScrollTrigger.min';
import './components/myScripts';
